import Home from "../pages/kitchen_staff/Home";
import MenuItems from "../pages/kitchen_staff/MenuItems";
import ViewOrder from "../pages/kitchen_staff/ViewOrder";

const KitchenRoutes = [
  { path: '/kitchen_staff', element: <Home />, exact: true },
  { path: '/kitchen_staff/home', element: <Home />, exact: true },
  { path: '/kitchen_staff/orders', element: <ViewOrder />, exact: true},
  { path: '/kitchen_staff/menu-items', element: <MenuItems />, exact: true},
];

export default KitchenRoutes;